import { reaction } from "mobx";
import { BaseListener } from "./base-listener";
export class DBGroupActivityListener extends BaseListener {
    constructor(db) {
        super("DBGroupActivityListener");
        Object.defineProperty(this, "db", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "usersPathRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "disposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "handleUsers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (snapshot) => {
                const { groupActivity } = this.db.stores;
                this.debugLogSnapshot("#handleUsers", snapshot);
                const value = snapshot.val() || {};
                const seen = new Set();
                Object.keys(value).forEach(userId => {
                    var _a;
                    const activity = (_a = value[userId]) === null || _a === void 0 ? void 0 : _a.activity;
                    if (activity && typeof activity.documentKey === "string") {
                        groupActivity.setActivity({
                            userId,
                            documentKey: activity.documentKey,
                            focus: activity.focus
                                ? { tileIds: activity.focus.tileIds || [] }
                                : undefined,
                            updatedAt: activity.updatedAt || 0
                        });
                        seen.add(userId);
                    }
                });
                // Remove users whose activity disappeared
                Array.from(groupActivity.activities.keys()).forEach(userId => {
                    if (!seen.has(userId))
                        groupActivity.removeActivity(userId);
                });
            }
        });
        this.db = db;
    }
    start() {
        return new Promise((resolve) => {
            this.disposer = reaction(() => this.db.stores.user.currentGroupId, groupId => this.subscribeToGroup(groupId), { fireImmediately: true });
            resolve();
        });
    }
    stop() {
        var _a;
        (_a = this.disposer) === null || _a === void 0 ? void 0 : _a.call(this);
        this.disposer = null;
        this.unsubscribeFromCurrentGroup();
    }
    subscribeToGroup(groupId) {
        this.unsubscribeFromCurrentGroup();
        if (!groupId)
            return;
        const { user } = this.db.stores;
        this.usersPathRef = this.db.firebase.ref(this.db.firebase.getGroupUsersPath(user, groupId));
        this.debugLogHandler("#subscribeToGroup", "adding", "on value", this.usersPathRef);
        this.usersPathRef.on("value", this.handleUsers);
    }
    unsubscribeFromCurrentGroup() {
        if (this.usersPathRef) {
            this.debugLogHandler("#unsubscribeFromCurrentGroup", "removing", "on value", this.usersPathRef);
            this.usersPathRef.off("value", this.handleUsers);
            this.usersPathRef = null;
        }
        this.db.stores.groupActivity.clear();
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGItZ3JvdXAtYWN0aXZpdHktbGlzdGVuZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2RiLWxpc3RlbmVycy9kYi1ncm91cC1hY3Rpdml0eS1saXN0ZW5lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsUUFBUSxFQUFxQixNQUFNLE1BQU0sQ0FBQztBQUVuRCxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFFL0MsTUFBTSxPQUFPLHVCQUF3QixTQUFRLFlBQVk7SUFLdkQsWUFBWSxFQUFNO1FBQ2hCLEtBQUssQ0FBQyx5QkFBeUIsQ0FBQyxDQUFDO1FBTDNCOzs7OztXQUFPO1FBQ1A7Ozs7bUJBQW1ELElBQUk7V0FBQztRQUN4RDs7OzttQkFBcUMsSUFBSTtXQUFDO1FBMEMxQzs7OzttQkFBYyxDQUFDLFFBQXdDLEVBQUUsRUFBRTtnQkFDakUsTUFBTSxFQUFFLGFBQWEsRUFBRSxHQUFHLElBQUksQ0FBQyxFQUFFLENBQUMsTUFBTSxDQUFDO2dCQUN6QyxJQUFJLENBQUMsZ0JBQWdCLENBQUMsY0FBYyxFQUFFLFFBQVEsQ0FBQyxDQUFDO2dCQUNoRCxNQUFNLEtBQUssR0FBRyxRQUFRLENBQUMsR0FBRyxFQUFFLElBQUksRUFBRSxDQUFDO2dCQUNuQyxNQUFNLElBQUksR0FBRyxJQUFJLEdBQUcsRUFBVSxDQUFDO2dCQUMvQixNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsRUFBRTs7b0JBQ2xDLE1BQU0sUUFBUSxHQUFHLE1BQUEsS0FBSyxDQUFDLE1BQU0sQ0FBQywwQ0FBRSxRQUFRLENBQUM7b0JBQ3pDLElBQUksUUFBUSxJQUFJLE9BQU8sUUFBUSxDQUFDLFdBQVcsS0FBSyxRQUFRLEVBQUUsQ0FBQzt3QkFDekQsYUFBYSxDQUFDLFdBQVcsQ0FBQzs0QkFDeEIsTUFBTTs0QkFDTixXQUFXLEVBQUUsUUFBUSxDQUFDLFdBQVc7NEJBQ2pDLEtBQUssRUFBRSxRQUFRLENBQUMsS0FBSztnQ0FDbkIsQ0FBQyxDQUFDLEVBQUUsT0FBTyxFQUFFLFFBQVEsQ0FBQyxLQUFLLENBQUMsT0FBTyxJQUFJLEVBQUUsRUFBRTtnQ0FDM0MsQ0FBQyxDQUFDLFNBQVM7NEJBQ2IsU0FBUyxFQUFFLFFBQVEsQ0FBQyxTQUFTLElBQUksQ0FBQzt5QkFDbkMsQ0FBQyxDQUFDO3dCQUNILElBQUksQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDLENBQUM7b0JBQ25CLENBQUM7Z0JBQ0gsQ0FBQyxDQUFDLENBQUM7Z0JBQ0gsMENBQTBDO2dCQUMxQyxLQUFLLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxVQUFVLENBQUMsSUFBSSxFQUFFLENBQUMsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEVBQUU7b0JBQzNELElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FBQzt3QkFBRSxhQUFhLENBQUMsY0FBYyxDQUFDLE1BQU0sQ0FBQyxDQUFDO2dCQUM5RCxDQUFDLENBQUMsQ0FBQztZQUNMLENBQUM7V0FBQztRQTdEQSxJQUFJLENBQUMsRUFBRSxHQUFHLEVBQUUsQ0FBQztJQUNmLENBQUM7SUFFTSxLQUFLO1FBQ1YsT0FBTyxJQUFJLE9BQU8sQ0FBTyxDQUFDLE9BQU8sRUFBRSxFQUFFO1lBQ25DLElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUN0QixHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsY0FBYyxFQUN4QyxPQUFPLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxnQkFBZ0IsQ0FBQyxPQUFPLENBQUMsRUFDekMsRUFBRSxlQUFlLEVBQUUsSUFBSSxFQUFFLENBQzFCLENBQUM7WUFDRixPQUFPLEVBQUUsQ0FBQztRQUNaLENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVNLElBQUk7O1FBQ1QsTUFBQSxJQUFJLENBQUMsUUFBUSxvREFBSSxDQUFDO1FBQ2xCLElBQUksQ0FBQyxRQUFRLEdBQUcsSUFBSSxDQUFDO1FBQ3JCLElBQUksQ0FBQywyQkFBMkIsRUFBRSxDQUFDO0lBQ3JDLENBQUM7SUFFTyxnQkFBZ0IsQ0FBQyxPQUEyQjtRQUNsRCxJQUFJLENBQUMsMkJBQTJCLEVBQUUsQ0FBQztRQUNuQyxJQUFJLENBQUMsT0FBTztZQUFFLE9BQU87UUFDckIsTUFBTSxFQUFFLElBQUksRUFBRSxHQUFHLElBQUksQ0FBQyxFQUFFLENBQUMsTUFBTSxDQUFDO1FBQ2hDLElBQUksQ0FBQyxZQUFZLEdBQUcsSUFBSSxDQUFDLEVBQUUsQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsUUFBUSxDQUFDLGlCQUFpQixDQUFDLElBQUksRUFBRSxPQUFPLENBQUMsQ0FBQyxDQUFDO1FBQzVGLElBQUksQ0FBQyxlQUFlLENBQUMsbUJBQW1CLEVBQUUsUUFBUSxFQUFFLFVBQVUsRUFBRSxJQUFJLENBQUMsWUFBWSxDQUFDLENBQUM7UUFDbkYsSUFBSSxDQUFDLFlBQVksQ0FBQyxFQUFFLENBQUMsT0FBTyxFQUFFLElBQUksQ0FBQyxXQUFXLENBQUMsQ0FBQztJQUNsRCxDQUFDO0lBRU8sMkJBQTJCO1FBQ2pDLElBQUksSUFBSSxDQUFDLFlBQVksRUFBRSxDQUFDO1lBQ3RCLElBQUksQ0FBQyxlQUFlLENBQUMsOEJBQThCLEVBQUUsVUFBVSxFQUFFLFVBQVUsRUFBRSxJQUFJLENBQUMsWUFBWSxDQUFDLENBQUM7WUFDaEcsSUFBSSxDQUFDLFlBQVksQ0FBQyxHQUFHLENBQUMsT0FBTyxFQUFFLElBQUksQ0FBQyxXQUFXLENBQUMsQ0FBQztZQUNqRCxJQUFJLENBQUMsWUFBWSxHQUFHLElBQUksQ0FBQztRQUMzQixDQUFDO1FBQ0QsSUFBSSxDQUFDLEVBQUUsQ0FBQyxNQUFNLENBQUMsYUFBYSxDQUFDLEtBQUssRUFBRSxDQUFDO0lBQ3ZDLENBQUM7Q0EwQkYifQ==